<template>
  <div>
    <v-data-table :items="groups" :headers="headers" :pagination="pagination"
                  @update:pagination="setPagination" class="edval-list">
      <template slot="items" slot-scope="group">
        <td>{{ group.item.name }}</td>
        <td class="buttonCell">
          <v-btn v-if="canSee || isManager(group.item)" icon
                 :to="`/groups/${group.item.id}`">
            <v-icon v-if="canEdit">edit</v-icon>
            <v-icon v-else>visibility</v-icon>
          </v-btn>
          <v-btn v-if="canEdit" icon @click="openDeleteModal(group.item)">
            <v-icon color="error">delete</v-icon>
          </v-btn>
        </td>
      </template>
      <div class="push-left" slot="actions">
        <v-subheader v-if="canEdit">
          Create group
          <v-btn icon to="/groups/new">
            <v-icon color="success">add_box</v-icon>
          </v-btn>
        </v-subheader>
        <v-subheader v-if="canEdit">
          Export groups
          <v-btn icon @click="exportGroups()">
            <v-icon color="primary">import_export</v-icon>
          </v-btn>
        </v-subheader>

      </div>
    </v-data-table>
    <confirm-delete-modal v-model="deleteModal.show"
                          :label="`group ${this.deleteModal.group.name}`" @delete="deleteGroup"/>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import ConfirmDeleteModal from '@/views/shared/ConfirmDeleteModal';
  import { saveAs } from 'file-saver';
  import moment from 'moment';

  export default {
    components: { ConfirmDeleteModal },
    data() {
      return {
        headers: [
          { text: 'Group', value: 'name' }
        ],
        deleteModal: {
          show: false,
          group: {}
        }
      };
    },
    computed: {
      canSee() {
        return this.$auth.hasPermission('VIEW_ALL_DATA') || this.canEdit;
      },
      canEdit() {
        return this.$auth.hasPermission('EDIT_ALL_USERS');
      },
      ...mapState('groups', [
        'pagination',
        'groups'
      ]),
      ...mapState('auth', {
        user: 'user',
        managesGroups: 'groups'
      })
    },
    methods: {
      openDeleteModal(group) {
        this.deleteModal = {
          show: true,
          group
        };
      },
      deleteGroup() {
        this.$services.authenticator.delete(`/groups/${this.deleteModal.group.id}`)
          .then(() => {
            this.show('Group deleted');
            this.reset();
            this.initialize();
          }).catch(this.$defaultHandlerHttp);
      },
      exportGroups() {
        this.$services.authenticator.get('/reports/groups/export')
          .then((response) => {
            const blob = new Blob([response.data], { type: 'text/csv' });
            saveAs(blob, `export_groups_${moment().format('YYYYMMDDhhmmss')}.csv`);
          })
          .catch(this.$defaultHandlerHttp);
      },

      isManager(group) {
        return this.managesGroups.map((g) => g.id)
          .indexOf(group.id) > -1;
      },
      ...mapActions('groups', [
        'setPagination',
        'initialize',
        'reset'
      ]),
      ...mapActions('alert', [
        'show'
      ])
    },
    mounted() {
      this.initialize().catch(this.$defaultHandlerHttp);
    }
  };
</script>

<style lang="less" scoped>
  @import '../../style/list.less';
</style>
